var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 13.4477 10.4477 13 11 13H11.01C11.5623 13 12.01 13.4477 12.01 14C12.01 14.5523 11.5623 15 11.01 15H11C10.4477 15 10 14.5523 10 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13C14.4477 13 14 13.4477 14 14C14 14.5523 14.4477 15 15 15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 17.4477 10.4477 17 11 17H11.01C11.5623 17 12.01 17.4477 12.01 18C12.01 18.5523 11.5623 19 11.01 19H11C10.4477 19 10 18.5523 10 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H15Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8293 6H19C20.6569 6 22 7.34315 22 9V21C22 22.6569 20.6569 24 19 24H9C7.34315 24 6 22.6569 6 21V9C6 7.34315 7.34315 6 9 6H10.1707C10.5825 4.83481 11.6938 4 13 4H15C16.3062 4 17.4175 4.83481 17.8293 6ZM10.1707 8H9C8.44772 8 8 8.44772 8 9V21C8 21.5523 8.44772 22 9 22H19C19.5523 22 20 21.5523 20 21V9C20 8.44772 19.5523 8 19 8H17.8293C17.4175 9.16519 16.3062 10 15 10H13C11.6938 10 10.5825 9.16519 10.1707 8ZM12 7C12 6.44772 12.4477 6 13 6H15C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H13C12.4477 8 12 7.55228 12 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.cf33a84ded0198c023cf16143c81b29b.svg";
export { ForwardRef as ReactComponent };